import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUpdateQuery } from '../app/useQueryParam';

export type BandTab = 'kom' | 'pipe' | 'flow' | 'src';

const DEFAULT_TAB: BandTab = 'kom';

/** Value of `?band=` for each tab (docs/c3/ARCHITECTURE.md, Routes). */
const TAB_PARAM: Record<BandTab, string> = {
  kom: 'metrics',
  pipe: 'pipeline',
  flow: 'flow',
  src: 'sources',
};

function tabFromParam(raw: string | null): BandTab {
  const found = (Object.keys(TAB_PARAM) as BandTab[]).find((tab) => TAB_PARAM[tab] === raw);
  return found ?? DEFAULT_TAB;
}

/** The metrics band's tab, kept in the query string. */
export function useBandRoute() {
  const [params] = useSearchParams();
  const updateQuery = useUpdateQuery();
  const tab = tabFromParam(params.get('band'));

  const setTab = useCallback(
    (next: BandTab) =>
      updateQuery((out) => {
        if (next === DEFAULT_TAB) out.delete('band');
        else out.set('band', TAB_PARAM[next]);
        // `?hide=band` belonged to the old header's Metrics button; drop it from old links.
        out.delete('hide');
      }),
    [updateQuery]
  );

  return { tab, showTab: setTab, setTab };
}
